import React from 'react';

export const ShutterLeftPostCenterOpening = (
  props: React.SVGProps<SVGSVGElement>,
) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      data-name="Layer 1"
      viewBox="0 0 103.22 59.4"
      width="111"
      {...props}
    >
      <g data-name="Group 83-2">
        <g data-name="Group 483">
          <path
            data-name="Rectangle 166"
            fill="#fff"
            d="M5.49.6h92.24v50.8H5.49z"
          />
          <path
            data-name="Path 2322"
            d="M4.72 51.4V.6a.69.69 0 01.77-.59h92.24a.71.71 0 01.77.59v50.8c0 .32-.35.58-.77.58H5.49a.68.68 0 01-.77-.58zM97 1.19H6.26v49.62H97z"
            fill="#dcd9d5"
          />
        </g>
        <g data-name="Group 484">
          <path
            data-name="Rectangle 167"
            fill="#fff"
            d="M5.49.6h92.24v50.8H5.49z"
          />
          <path
            data-name="Path 2323"
            d="M4.72 51.4V.6a.69.69 0 01.77-.59h92.24a.71.71 0 01.77.59v50.8c0 .32-.35.58-.77.58H5.49a.68.68 0 01-.77-.58zM97 1.19H6.26v49.62H97z"
            fill="#dcd9d5"
          />
        </g>
        <g data-name="Group 485" fill="#dcd9d5">
          <path data-name="Rectangle 168" d="M9.9 3.95h83.42v44.1H9.9z" />
          <path
            data-name="Path 2324"
            d="M9.89 48.63c-.42 0-.77-.26-.76-.58V3.95c0-.32.34-.58.77-.58h83.42c.42 0 .77.26.77.58v44.06c0 .32-.35.58-.77.58H9.89zM92.55 4.54H10.67v42.92h81.88z"
          />
        </g>
        <path
          data-name="Path 2325"
          d="M.73 51.95h101.76c.4 0 .73-.25.73-.55a.65.65 0 00-.73-.56H.73a.65.65 0 00-.73.56c0 .3.33.55.73.55z"
          fill="#dcd9d5"
        />
      </g>
      <g data-name="Group 85">
        <g data-name="Group 498">
          <path
            data-name="Rectangle 182"
            fill="#233762"
            d="M68.17 8.38l27.78-6.03v49.49l-27.78 6.8V8.38z"
          />
          <path
            data-name="Path 2338"
            d="M96.44 52.34L67.66 59.4V7.86l28.78-6.24zm-27.78 5.55l26.8-6.55V3.08L68.66 8.9z"
            fill="#fff"
          />
        </g>
        <g data-name="Group 499">
          <path
            data-name="Rectangle 183"
            fill="#233762"
            d="M71.17 13.04l22.04-4.85v3.57l-22.04 4.89v-3.61z"
          />
          <path
            data-name="Path 2339"
            d="M93.46 12.01l-22.55 5v-4.24l22.55-5zm-22 4.23L93 11.49V8.57l-21.57 4.74z"
            fill="#fff"
          />
        </g>
        <g data-name="Group 500">
          <path
            data-name="Rectangle 184"
            fill="#233762"
            d="M71.17 16.65l22.04-4.89v3.57l-22.04 4.93v-3.61z"
          />
          <path
            data-name="Path 2340"
            d="M93.46 15.59l-22.55 5v-4.21l22.55-5zm-22 4.28L93 15.06v-2.92l-21.57 4.78z"
            fill="#fff"
          />
        </g>
        <g data-name="Group 501">
          <path
            data-name="Rectangle 185"
            fill="#233762"
            d="M71.17 20.26l22.04-4.93v3.56l-22.04 4.98v-3.61z"
          />
          <path
            data-name="Path 2341"
            d="M93.46 19.16l-22.55 5.1v-4.25l22.55-5zm-22 4.33L93 18.63v-2.92l-21.57 4.82z"
            fill="#fff"
          />
        </g>
        <g data-name="Group 502">
          <path
            data-name="Rectangle 186"
            fill="#233762"
            d="M71.17 23.9l22.04-4.98v3.57l-22.04 5.02V23.9z"
          />
          <path
            data-name="Path 2342"
            d="M93.46 22.75L70.91 27.9v-4.27l22.55-5.09zm-22 4.37L93 22.22V19.3l-21.57 4.87z"
            fill="#fff"
          />
        </g>
        <g data-name="Group 503">
          <path
            data-name="Rectangle 187"
            fill="#233762"
            d="M71.17 27.51l22.04-5.02v3.56l-22.04 5.07v-3.61z"
          />
          <path
            data-name="Path 2343"
            d="M93.46 26.32l-22.55 5.19v-4.27l22.55-5.14zm-22 4.41L93 25.79v-2.92l-21.57 4.91z"
            fill="#fff"
          />
        </g>
        <g data-name="Group 504">
          <path
            data-name="Rectangle 188"
            fill="#233762"
            d="M71.17 31.12l22.04-5.07v3.57l-22.04 5.11v-3.61z"
          />
          <path
            data-name="Path 2344"
            d="M93.46 29.89l-22.55 5.23v-4.27l22.55-5.18zm-22 4.45l21.52-5v-2.9l-21.55 4.95z"
            fill="#fff"
          />
        </g>
        <g data-name="Group 505">
          <path
            data-name="Rectangle 189"
            fill="#233762"
            d="M71.17 34.73l22.04-5.11v3.57l-22.04 5.15v-3.61z"
          />
          <path
            data-name="Path 2345"
            d="M93.46 33.45l-22.55 5.28v-4.26l22.55-5.23zm-22.03 4.56l21.57-5v-3l-21.57 5z"
            fill="#fff"
          />
        </g>
        <g data-name="Group 506">
          <path
            data-name="Rectangle 190"
            fill="#233762"
            d="M71.17 38.34l22.04-5.15v3.57l-22.04 5.2v-3.62z"
          />
          <path
            data-name="Path 2346"
            d="M93.46 37.01l-22.55 5.33v-4.26l22.55-5.27zm-22 4.55L93 36.49v-2.92l-21.52 5z"
            fill="#fff"
          />
        </g>
        <g data-name="Group 507">
          <path
            data-name="Rectangle 191"
            fill="#233762"
            d="M71.17 41.96l22.04-5.2v3.56l-22.04 5.25v-3.61z"
          />
          <path
            data-name="Path 2347"
            d="M93.46 40.59l-22.55 5.42v-4.32l22.55-5.32zm-22 4.59L93 40.06v-2.92l-21.57 5.08z"
            fill="#fff"
          />
        </g>
        <g data-name="Group 508">
          <path
            data-name="Rectangle 192"
            fill="#233762"
            d="M71.17 45.59l22.04-5.24v3.57l-22.04 5.29v-3.62z"
          />
          <path
            data-name="Path 2348"
            d="M93.46 44.18l-22.55 5.41v-4.26l22.55-5.32zm-22 4.64L93 43.65v-2.92l-21.57 5.13z"
            fill="#fff"
          />
        </g>
        <g data-name="Group 509">
          <path
            data-name="Rectangle 193"
            fill="#233762"
            d="M71.17 49.21l22.04-5.29v3.56l-22.04 5.34v-3.61z"
          />
          <path
            data-name="Path 2349"
            d="M93.46 47.75l-22.55 5.46v-4.27l22.55-5.41zm-22 4.68L93 47.22V44.3l-21.57 5.17z"
            fill="#fff"
          />
        </g>
        <path
          data-name="Rectangle 194"
          fill="#fff"
          d="M81.63 10.74l1.44-.32v39.52l-1.44.34V10.74z"
        />
      </g>
      <g data-name="Group 85-2">
        <g data-name="Group 498-2">
          <path
            data-name="Rectangle 182-2"
            fill="#233762"
            d="M34.54 8.28L6.75 2.25v49.49l27.79 6.8V8.28z"
          />
          <path
            data-name="Path 2338-2"
            d="M6.26 1.53L35 7.76V59.3l-28.78-7zM34 8.8L7.24 3.01v48.23L34 57.79z"
            fill="#fff"
          />
        </g>
        <g data-name="Group 499-2">
          <path
            data-name="Rectangle 183-2"
            fill="#233762"
            d="M31.54 12.94L9.49 8.09v3.57l22.05 4.89v-3.61z"
          />
          <path
            data-name="Path 2339-2"
            d="M9.24 7.72l22.55 5v4.29l-22.55-5zm22 5.49L9.75 8.47v2.92l21.52 4.77z"
            fill="#fff"
          />
        </g>
        <g data-name="Group 500-2">
          <path
            data-name="Rectangle 184-2"
            fill="#233762"
            d="M31.54 16.55L9.49 11.66v3.57l22.05 4.93v-3.61z"
          />
          <path
            data-name="Path 2340-2"
            d="M9.24 11.28l22.55 5v4.27L9.24 15.49zm22 5.54L9.75 12.01v3l21.52 4.81z"
            fill="#fff"
          />
        </g>
        <g data-name="Group 501-2">
          <path
            data-name="Rectangle 185-2"
            fill="#233762"
            d="M31.54 20.16L9.49 15.23v3.57l22.05 4.97v-3.61z"
          />
          <path
            data-name="Path 2341-2"
            d="M9.24 14.85l22.55 5v4.27L9.24 19.06zm22 5.58L9.75 15.61v2.92l21.52 4.86z"
            fill="#fff"
          />
        </g>
        <g data-name="Group 502-2">
          <path
            data-name="Rectangle 186-2"
            fill="#233762"
            d="M31.54 23.8L9.49 18.82v3.57l22.05 5.02V23.8z"
          />
          <path
            data-name="Path 2342-2"
            d="M9.24 18.44l22.55 5.09v4.27L9.24 22.65zm22 5.63L9.75 19.2v2.92l21.52 4.89z"
            fill="#fff"
          />
        </g>
        <g data-name="Group 503-2">
          <path
            data-name="Rectangle 187-2"
            fill="#233762"
            d="M31.54 27.41L9.49 22.39v3.57l22.05 5.06v-3.61z"
          />
          <path
            data-name="Path 2343-2"
            d="M9.24 22.01l22.55 5.13v4.27L9.24 26.22zm22 5.67L9.75 22.77v2.92l21.52 4.94z"
            fill="#fff"
          />
        </g>
        <g data-name="Group 504-2">
          <path
            data-name="Rectangle 188-2"
            fill="#233762"
            d="M31.54 31.02L9.49 25.96v3.56l22.05 5.11v-3.61z"
          />
          <path
            data-name="Path 2344-2"
            d="M9.24 25.57l22.55 5.18v4.26L9.24 29.79zm22 5.72l-21.52-5v2.92l21.52 5z"
            fill="#fff"
          />
        </g>
        <g data-name="Group 505-2">
          <path
            data-name="Rectangle 189-2"
            fill="#233762"
            d="M31.54 34.63L9.49 29.52v3.57l22.05 5.15v-3.61z"
          />
          <path
            data-name="Path 2345-2"
            d="M9.24 29.14l22.55 5.23v4.26L9.24 33.35zm22 5.76l-21.52-5v2.93l21.52 5z"
            fill="#fff"
          />
        </g>
        <g data-name="Group 506-2">
          <path
            data-name="Rectangle 190-2"
            fill="#233762"
            d="M31.54 38.24L9.49 33.09v3.57l22.05 5.2v-3.62z"
          />
          <path
            data-name="Path 2346-2"
            d="M9.24 32.71l22.55 5.3v4.27L9.24 36.92zm22 5.8l-21.52-5v2.92l21.52 5.08z"
            fill="#fff"
          />
        </g>
        <g data-name="Group 507-2">
          <path
            data-name="Rectangle 191-2"
            fill="#233762"
            d="M31.54 41.86l-22.05-5.2v3.56l22.05 5.25v-3.61z"
          />
          <path
            data-name="Path 2347-2"
            d="M9.24 36.28l22.55 5.31v4.27L9.24 40.49zm22 5.84L9.75 37.01v3l21.52 5.12z"
            fill="#fff"
          />
        </g>
        <g data-name="Group 508-2">
          <path
            data-name="Rectangle 192-2"
            fill="#233762"
            d="M31.54 45.49L9.49 40.25v3.57l22.05 5.29v-3.62z"
          />
          <path
            data-name="Path 2348-2"
            d="M9.24 39.87l22.55 5.36v4.27L9.24 44.08zm22 5.89L9.75 40.63v2.92l21.52 5.17z"
            fill="#fff"
          />
        </g>
        <g data-name="Group 509-2">
          <path
            data-name="Rectangle 193-2"
            fill="#233762"
            d="M31.54 49.11L9.49 43.82v3.57l22.05 5.33v-3.61z"
          />
          <path
            data-name="Path 2349-2"
            d="M9.24 43.43l22.55 5.41v4.27L9.24 47.65zm22 5.94L9.75 44.2v2.92l21.52 5.21z"
            fill="#fff"
          />
        </g>
        <path
          data-name="Rectangle 194-2"
          fill="#fff"
          d="M21.07 10.64l-1.44-.32v39.52l1.44.35V10.64z"
        />
      </g>
      <g data-name="Group 85-3">
        <g data-name="Group 498-3">
          <path
            data-name="Rectangle 182-3"
            fill="#233762"
            d="M64.67 8.28L36.89 2.25v49.49l27.78 6.8V8.28z"
          />
          <path
            data-name="Path 2338-3"
            d="M36.39 1.53l28.78 6.23V59.3l-28.78-7zM64.16 8.8L37.37 3.01v48.23l26.8 6.55z"
            fill="#fff"
          />
        </g>
        <g data-name="Group 499-3">
          <path
            data-name="Rectangle 183-3"
            fill="#233762"
            d="M61.67 12.94L39.63 8.09v3.57l22.04 4.89v-3.61z"
          />
          <path
            data-name="Path 2339-3"
            d="M39.37 7.72l22.55 5v4.29l-22.55-5zm22 5.49L39.88 8.47v2.92l21.52 4.77z"
            fill="#fff"
          />
        </g>
        <g data-name="Group 500-3">
          <path
            data-name="Rectangle 184-3"
            fill="#233762"
            d="M61.67 16.55l-22.04-4.89v3.57l22.04 4.93v-3.61z"
          />
          <path
            data-name="Path 2340-3"
            d="M39.37 11.28l22.55 5v4.27l-22.55-5.06zm22 5.54l-21.49-4.81v3l21.52 4.81z"
            fill="#fff"
          />
        </g>
        <g data-name="Group 501-3">
          <path
            data-name="Rectangle 185-3"
            fill="#233762"
            d="M61.67 20.16l-22.04-4.93v3.57l22.04 4.97v-3.61z"
          />
          <path
            data-name="Path 2341-3"
            d="M39.37 14.85l22.55 5v4.27l-22.55-5.11zm22 5.58l-21.49-4.82v2.92l21.52 4.86z"
            fill="#fff"
          />
        </g>
        <g data-name="Group 502-3">
          <path
            data-name="Rectangle 186-3"
            fill="#233762"
            d="M61.67 23.8l-22.04-4.98v3.57l22.04 5.02V23.8z"
          />
          <path
            data-name="Path 2342-3"
            d="M39.37 18.44l22.55 5.09v4.27l-22.55-5.15zm22 5.63L39.88 19.2v2.92l21.52 4.89z"
            fill="#fff"
          />
        </g>
        <g data-name="Group 503-3">
          <path
            data-name="Rectangle 187-3"
            fill="#233762"
            d="M61.67 27.41l-22.04-5.02v3.57l22.04 5.06v-3.61z"
          />
          <path
            data-name="Path 2343-3"
            d="M39.37 22.01l22.55 5.13v4.27l-22.55-5.19zm22 5.67l-21.49-4.91v2.92l21.52 4.94z"
            fill="#fff"
          />
        </g>
        <g data-name="Group 504-3">
          <path
            data-name="Rectangle 188-3"
            fill="#233762"
            d="M61.67 31.02l-22.04-5.06v3.56l22.04 5.11v-3.61z"
          />
          <path
            data-name="Path 2344-3"
            d="M39.37 25.57l22.55 5.18v4.26l-22.55-5.22zm22 5.72l-21.52-5v2.92l21.52 5z"
            fill="#fff"
          />
        </g>
        <g data-name="Group 505-3">
          <path
            data-name="Rectangle 189-3"
            fill="#233762"
            d="M61.67 34.63l-22.04-5.11v3.57l22.04 5.15v-3.61z"
          />
          <path
            data-name="Path 2345-3"
            d="M39.37 29.14l22.55 5.23v4.26l-22.55-5.28zm22 5.76l-21.52-5v2.93l21.52 5z"
            fill="#fff"
          />
        </g>
        <g data-name="Group 506-3">
          <path
            data-name="Rectangle 190-3"
            fill="#233762"
            d="M61.67 38.24l-22.04-5.15v3.57l22.04 5.2v-3.62z"
          />
          <path
            data-name="Path 2346-3"
            d="M39.37 32.71l22.55 5.3v4.27l-22.55-5.36zm22 5.8l-21.52-5v2.92l21.52 5.08z"
            fill="#fff"
          />
        </g>
        <g data-name="Group 507-3">
          <path
            data-name="Rectangle 191-3"
            fill="#233762"
            d="M61.67 41.86l-22.04-5.2v3.56l22.04 5.25v-3.61z"
          />
          <path
            data-name="Path 2347-3"
            d="M39.37 36.28l22.55 5.31v4.27l-22.55-5.37zm22 5.84l-21.49-5.11v3l21.52 5.12z"
            fill="#fff"
          />
        </g>
        <g data-name="Group 508-3">
          <path
            data-name="Rectangle 192-3"
            fill="#233762"
            d="M61.67 45.49l-22.04-5.24v3.57l22.04 5.29v-3.62z"
          />
          <path
            data-name="Path 2348-3"
            d="M39.37 39.87l22.55 5.36v4.27l-22.55-5.42zm22 5.89l-21.49-5.13v2.92l21.52 5.17z"
            fill="#fff"
          />
        </g>
        <g data-name="Group 509-3">
          <path
            data-name="Rectangle 193-3"
            fill="#233762"
            d="M61.67 49.11l-22.04-5.29v3.57l22.04 5.33v-3.61z"
          />
          <path
            data-name="Path 2349-3"
            d="M39.37 43.43l22.55 5.41v4.27l-22.55-5.46zm22 5.94L39.88 44.2v2.92l21.52 5.21z"
            fill="#fff"
          />
        </g>
        <path
          data-name="Rectangle 194-3"
          fill="#fff"
          d="M51.21 10.64l-1.44-.32v39.52l1.44.35V10.64z"
        />
      </g>
      <path fill="#233762" d="M35.04 3.43h1.36v45.21h-1.36z" />
    </svg>
  );
};
